import { motion } from "framer-motion";

// Module-level constants — stable references prevent framer-motion from
// re-computing transitions on every parent render.
const REVEAL_INITIAL = { opacity: 0 };
const REVEAL_ANIMATE = { opacity: 1, y: 0 };
const REVEAL_TRANSITION_EASE = [0.22, 1, 0.36, 1];
const REVEAL_VIEWPORT_MARGIN = "-60px";

/**
 * Scroll-triggered fade + slide-up. Works everywhere (mobile → desktop).
 * Uses IntersectionObserver via Motion's whileInView.
 */
export default function Reveal({
  children,
  as: Tag = "div",
  delay = 0,
  y = 16,
  className = "",
  once = true,
  ...rest
}) {
  const MotionTag = motion[Tag] || motion.div;
  return (
    <MotionTag
      initial={{ ...REVEAL_INITIAL, y }}
      whileInView={REVEAL_ANIMATE}
      viewport={{ once, margin: REVEAL_VIEWPORT_MARGIN }}
      transition={{ duration: 0.55, delay, ease: REVEAL_TRANSITION_EASE }}
      className={className}
      {...rest}
    >
      {children}
    </MotionTag>
  );
}
